import { render, staticRenderFns } from "./AccountForm.vue?vue&type=template&id=014caa95"
import script from "./AccountForm.vue?vue&type=script&lang=js"
export * from "./AccountForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports